/*
 * Define a form page to display a list of Empolyee types.
 * Include the Other input option.
 * The list of choices must be provided by the calling function.
 */
import css from './pages.module.css'
import { choicePage } from './choicePage'

export const employeeTypePage = propOverrides => {
  const props = {
    pageId: 'employee_type_page',
    fieldName: 'employee_type',
    choices: [],
    label: 'What type of employee, contractor, or grantee are you?',
    className: css.choices,
    labelClassName: css.largeLabel,
    fieldNameOther: 'employee_type_other',
    labelOther: 'Please enter the other employee type',
    ...propOverrides
  }

  return choicePage({ ...props })
}
